import { createContext, useEffect, useState, useRef, useContext, useMemo } from "react";
import { SharedStateEvent, updateSharedState } from "src/utils/shared-state";
import {
  playing as init_playing,
  speed as init_speed,
  initIdx,
} from "./initData";
import { DataContext } from "./DataContext";
const TimingContext = createContext();

// Creating a provider component
const TimingProvider = ({ children }) => {
  const { data } = useContext(DataContext);
  const [playing, setPlaying] = useState(init_playing);
  const [speed, setSpeed] = useState(init_speed);
  const [idx] = useState(initIdx);
  const intervalRef = useRef();

  const sampleRate = useMemo(() => data[0]?.sample_rate, [data]);

  useEffect(() => {
    if (!playing) {
      clearInterval(intervalRef.current);
    } else {
      if (intervalRef.current) clearInterval(intervalRef.current);
      const window_interval = sampleRate * 1000 / speed;
      const window_step = 1;
      intervalRef.current = setInterval(() => {
        const newIDX = window.sharedState.idx + window_step;
        updateSharedState(SharedStateEvent.IDX_UPDATE, { idx: newIDX });
      }, window_interval);
    }
  }, [playing, sampleRate, speed]);

  useEffect(() => {
    updateSharedState(SharedStateEvent.PLAYBACK_UPDATE, {
      playback: { playing, speed },
    });
  }, [playing, speed]);

  return (
    <TimingContext.Provider
      value={{
        playing,
        setPlaying,
        speed,
        setSpeed,
        idx,
      }}
    >
      {children}
    </TimingContext.Provider>
  );
};

export { TimingContext, TimingProvider };
